<script>
export default {
  name: 'Note',
  props: ['title', 'content', 'componentIndex'],
  data() {
    return {
      type: ''
    }
  },
  methods: {
    deleteNote: function() {
      this.$emit('deleteNote');
    },
    updateTitle: function(e) {
      this.$emit('updateTitle', e.target.value, this.componentIndex);
    },
    updateContent: function(e) {
      this.$emit('updateContent', e.target.value, this.componentIndex);
    }
  }
}
</script>